import React, { useEffect, useRef, useState } from "react";
import downloadIcon from "../../../../asset/images/download-arrow.svg";
import downIcon from "../../../../asset/images/download-orange-arrow.svg";
import attachIcon from "../../../../asset/images/attach.svg";
import { toast } from "react-toastify";
import SmallLoader from "../../../../Components/Common/smallLoader";
import { decryptData, toSentenceCase, validateFileExcel } from "../../../../CommonMethhods/CommonMethods";
import axiosInstance, { axiosMultipart1 } from "../../../../CommonMethhods/axiosInstance";
import { Dealer_Mapping } from "../../../../Configuration/API_URL";
import uploadIcon from "../../../../asset/images/upload-file.svg";
import closeIcon from "../../../../asset/images/close-gray.svg";

function UploadFile({ onUpload, selectedRequest, isFromMyRequest, rowData }) {
  const [submitLoader, setSubmitLoader] = useState(false);
  const mappingFileRef = useRef(null);
  const approvalFileRef = useRef(null);
  const [docLoader, setDocLoader] = useState(false)
  const [mappingFile, setMappingFile] = useState(null);
  const [approvalDoc, setApprovalDoc] = useState(null);
  const [batchId, setBatchId] = useState("");
  const [approvalDocLink, setApprovalDocLink] = useState("");

  const handleMappingUploadClick = () => {
    mappingFileRef.current?.click();
  };

  const handleApprovalUploadClick = () => {
    approvalFileRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!validateFileExcel(file)) {
      e.target.value = "";
      return;
    }

    setMappingFile(file);
  };
  console.log(rowData, "rowDataBulk");

  const hasApprovalDoc = approvalDoc || approvalDocLink;
  const hasMappingFile = mappingFile;

  useEffect(() => {
    if (!isFromMyRequest || !rowData) return;
    setApprovalDocLink(rowData?.approvalDocLink || "");
  }, [rowData, isFromMyRequest]);

  const supportingDocName = approvalDocLink
    ? decodeURIComponent(
      approvalDocLink
        .split("/")
        .pop()
        .split("?")[0]
    )
    : "";

  const handleApprovalFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const validTypes = [
      ".pdf",
      ".jpg",
      ".jpeg",
      ".png",
      ".bmp",
    ];

    const isValid = validTypes.some((type) =>
      file.name.toLowerCase().endsWith(type)
    );

    if (!isValid) {
      toast.error(
        "Only PDF/JPG/JPEG/PNG/BMP files are allowed"
      );
      return;
    }
    setApprovalDoc(file);
  };

  const downlodDocument = async () => {
    setDocLoader(true);

    try {
      const getDetails = await axiosInstance.get(
        Dealer_Mapping.bulkDownloadTemplate,
      );

      const decrypted = JSON.parse(
        decryptData(getDetails?.data)
      );

      if (decrypted?.status === 0) {
        toast.success(decrypted?.message);
        window.open(decrypted?.data?.url, "_self", "noopener,noreferrer");
      } else {
        toast.error(decrypted?.message);
      }
    } catch (error) {
      console.log(error);

    } finally {
      setDocLoader(false);
    }
  };

  const handleValidatePreview = async () => {
    validateBulkData()
  };

  const validateBulkData = async () => {
    setSubmitLoader(true);
    const formData = new FormData();
    formData.append("file", mappingFile);
    formData.append("approval-doc", hasApprovalDoc);


    try {
      let url = "";
      let response;

      if (isFromMyRequest) {
        url = `${Dealer_Mapping.singleMappingSubmit}/${selectedRequest?.batchId}/submit?draft=true`;

        response = await axiosMultipart1.put(url, formData);
      } else {
        url = `${Dealer_Mapping.bulkValidate}?draft=true`;

        response = await axiosMultipart1.post(url, formData);
      }

      const decryptedresp = decryptData(response.data);
      const decrypted = JSON.parse(decryptedresp)

      console.log(decrypted, "decryptedbulk");

      if (decrypted?.status === 0) {
        setBatchId(decrypted?.data?.batchId)
        toast.success(decrypted.message);
        onUpload(decrypted.data);
      } else {
        toast.error(decrypted.message);
      }
    } catch (error) {
      const decryptedResp = decryptData(error?.response?.data);
      const decryptedError = JSON.parse(decryptedResp);
      toast.error(decryptedError?.message)
      console.log(decryptedError);
    } finally {
      setSubmitLoader(false);
    }
  };

  const clearFile = (type) => {
    if (type?.toLowerCase() === "mapping") {
      setMappingFile(null);

      if (mappingFileRef.current) {
        mappingFileRef.current.value = "";
      }
    }

    if (type?.toLowerCase() === "approval") {
      setApprovalDoc(null);
      setApprovalDocLink("");

      if (approvalFileRef.current) {
        approvalFileRef.current.value = "";
      }
    }
  };


  const handleClear = () => {
    clearFile("mapping");
    clearFile("approval");
  };

  const getStatusClass = (status = "") => {
    switch (status.toLowerCase()) {
      case "pending":
        return "status-pending";
      case "approved":
        return "status-approved";
      case "rejected":
        return "status-rejected";
      case "draft":
        return "status-draft";
      case "partial":
        return "status-partial";
      default:
        return "";
    }
  };

  const handlePreviewApprovalDoc = () => {
    if (approvalDoc instanceof File) {
      const fileUrl = URL.createObjectURL(approvalDoc);
      window.open(fileUrl, "_blank", "noopener,noreferrer");

      setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
      return;
    }
    if (approvalDocLink) {
      window.open(approvalDocLink, "_blank", "noopener,noreferrer");
    }
  };

  const handlePreviewMappingFile = () => {
    if (!mappingFile) return;

    const fileUrl = URL.createObjectURL(mappingFile);
    window.open(fileUrl, "_blank", "noopener,noreferrer");

    setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
  };

  return (
    <>
      <div className="wrap-downloads">
        <div className="content-icon">
          <div className="wrap-icon">
            <img src={downloadIcon} alt="icon" />
          </div>
          <div className="download-text">
            <span className="down-temp">Download Template</span>
            <span className="col-text">Pre-formatted Excel with correct headers · Do not alter headers</span>
          </div>
        </div>

        <div className="wrap-down-btn"
          tabIndex={0}
          role="button"
          onClick={downlodDocument}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              downlodDocument();
            }
          }}>
          {docLoader ?
            <SmallLoader />
            :
            <>
              <img src={downIcon} alt="download-icon" />
              <button className="download-template">DOWNLOAD</button>
            </>
          }
        </div>
      </div>

      <div className="wrap-bulk-section">
        <div className="batch-upload-wrapper">
          <div className="step-content upload-box-width">
            <div className="upload-box new-mapping-content">

              <div className="wrap-file-upload">
                {selectedRequest?.batchId ?

                  <div className="wrap-title-batch">
                    <div className="status-content">
                      <span className="ckr-section-title">{selectedRequest?.batchId}</span>
                      {selectedRequest?.status !== "" ?
                        <span className={getStatusClass(selectedRequest?.status)}>
                          {toSentenceCase(selectedRequest?.status)}
                        </span>
                        : "-"}
                    </div>
                    <span className="upload-text">Upload Mapping File</span>
                  </div>

                  :
                  <span className="upload-text">Upload Mapping File</span>
                }

                {mappingFile ?
                  <div className="dealer-doc-upload">

                    <div className="wrap-upload-section"
                    >
                      <div className="wrap-docname">
                        <img src={uploadIcon} alt="upload icon" />

                        <span className="upload-doc-btn" onClick={handlePreviewMappingFile}>
                          {mappingFile?.name}
                        </span>
                      </div>

                      <img
                        className="close"
                        src={closeIcon}
                        alt="close"
                        style={{ cursor: "pointer" }}
                        onClick={() => clearFile("mapping")}
                      />
                      <input
                        type="file"
                        style={{ display: "none" }}
                        accept=".xlsx,.xls,.csv"
                      />
                    </div>

                  </div>
                  :

                  <div className="wrap-drag-drop"
                    tabIndex={0}
                    role="button"
                    onClick={handleMappingUploadClick}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleMappingUploadClick();
                      }
                    }}>

                    <div className="upload-area">
                      <img src={attachIcon} alt="attach icon" />

                      <div className="wrap-input-cont">
                        <span className="drag-text">Drop approval document here</span>
                        <span className="upload-info">
                          .xlsx, .xls, .csv · Max 5,000 rows· Max 10 MB
                        </span>
                        <input
                          type="file"
                          ref={mappingFileRef}
                          hidden
                          accept=".xlsx,.xls,.csv"
                          id="fileUpload"
                          onChange={handleFileChange}
                        />
                        <label className="select-file bold-text">Select File</label>
                      </div>
                    </div>
                  </div>
                }
              </div>

            </div>

          </div>

          <div className="wrap-preview-section">

            <div className="step-content mb-extra">
              <div className="preview-wrapper">

                <div className="summary-title-wrap batch-wrap">
                  <span className="summary-title">Batch Details</span>
                </div>

                <div className="title-batch">
                  <span className="ref">Batch Approval Document <span className="error-mark">*</span></span>
                  {!approvalDoc && !approvalDocLink ?
                    <>
                      <div className="wrap-drag-drop branch-doc-wrap" tabIndex={0}
                        role="button"
                        onClick={handleApprovalUploadClick}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleApprovalUploadClick();
                          }
                        }}>

                        <div className="upload-area">


                          <div className="wrap-input-cont">
                            <span className="drag-text">Attach batch approval</span>
                            <input
                              type="file"
                              ref={approvalFileRef}
                              hidden
                              accept=".pdf,.jpg,.jpeg,.png,.bmp"
                              id="fileUpload"
                              onChange={handleApprovalFileChange}

                            />
                          </div>
                          <img src={attachIcon} alt="attach icon" />
                        </div>
                      </div>
                      <span className="upload-batch-info">
                        Maximum file size: 10 MB, PDF/JPG/JPEG/PNG/BMP
                      </span>
                    </>
                    :
                    <div className="dealer-doc-upload">

                      <div className="wrap-upload-section"
                      >
                        <div className="wrap-docname">
                          <img src={uploadIcon} alt="upload icon" />

                          <span className="upload-doc-btn" onClick={handlePreviewApprovalDoc}>
                            {approvalDoc?.name || rowData?.approvalDocFilename}
                          </span>
                        </div>

                        <img
                          className="close"
                          src={closeIcon}
                          alt="close"
                          style={{ cursor: "pointer" }}
                          onClick={() => clearFile("approval")}
                        />
                        <input
                          type="file"
                          style={{ display: "none" }}
                          accept=".pdf,.jpg,.png,.jpeg,.bmp"
                        />
                      </div>

                    </div>
                  }
                </div>
              </div>

            </div>

          </div>
        </div>
        <div className="format-table-section">
          <div className="ckr-section-header">
            <p className="ckr-section-title">File Format Guide</p>
          </div>
          <div className="ckr-table-wrapper scroll-table format-guide-table">
            <table className="ckr-table draft-maker">
              <thead>
                <tr>
                  <th>Column</th>
                  <th>Required?</th>
                  <th>Example</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Request Date</td>
                  <td>Required</td>
                  <td>YYYY-MM-DD</td>

                </tr>
                <tr>
                  <td>Client Code</td>
                  <td>Required</td>
                  <td>00547</td>

                </tr>
                <tr>
                  <td>Client Name</td>
                  <td>Optional</td>
                  <td>Piyush Goyal</td>

                </tr>
                <tr>
                  <td>Old Dealer Code</td>
                  <td>Optional</td>
                  <td>A123 (blank=new)</td>

                </tr>
                <tr>
                  <td>New Dealer Code</td>
                  <td>Required</td>
                  <td>487874</td>

                </tr>
                <tr>
                  <td>Effective Date</td>
                  <td>Optional</td>
                  <td>15-01-2026</td>

                </tr>
                <tr>
                  <td>Reason for Change</td>
                  <td>Required</td>
                  <td>For Better Service</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="mapping-footer-actions">
        <button
          className={`back-btn ${!hasMappingFile && !hasApprovalDoc ? "disabled-btn-back" : ""
            }`}
          onClick={handleClear}
          disabled={!hasMappingFile && !hasApprovalDoc}
        >
          CLEAR
        </button>
        <button
          className={`submit-btns ${!hasMappingFile || !hasApprovalDoc ? "disabled-btn" : ""
            }`}
          onClick={handleValidatePreview}
          disabled={!hasMappingFile || !hasApprovalDoc}
        >
          {submitLoader ?
            <SmallLoader />
            : <>
              VALIDATE & PREVIEW
            </>}

        </button>
      </div>
    </>
  );
}

export default UploadFile;